module.exports = __webpack_public_path__ + "img/8.ced35e7c.jpg";